export default __webpack_public_path__ + "static/media/image21.f2c85686.png";